import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
const ChronicDiseases = () => {
  return <>
      <section id="chronic-diseases" className="py-16">
        <div className="container mx-auto px-4">
          <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 bg-[#b9d5d2]/20">
            <CardHeader className="flex flex-row items-center gap-4">
              <div className="p-4 rounded-full bg-[#b9d5d2]/50">
                <Heart className="w-8 h-8 text-[#167067]" />
              </div>
              <h2 className="text-xl font-semibold text-primary leading-none tracking-tight">
                Chronic Diseases
              </h2>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">
                
                
                <h3 className="text-lg font-semibold text-primary mt-8">Dietary Management of Chronic Conditions</h3>
                <p className="text-gray-600 leading-relaxed">Nutrition plays a critical role in managing chronic diseases. Our dietitians work with you and your healthcare team to develop personalised nutrition plans that help manage your condition and improve quality of life.</p>
                
                <h3 className="text-lg font-semibold text-primary">Conditions We Help Manage</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600 grid grid-cols-1 md:grid-cols-2">
                  <li>Diabetes (Type 1, 2, Gestational)</li>
                  <li>Hypertension (High Blood Pressure)</li>
                  <li>Dyslipidemia (High Cholesterol)</li>
                  <li>Polycystic Ovary Syndrome (PCOS)</li>
                  <li>Hypothyroidism</li>
                  <li>Chronic Kidney Disease</li>
                  <li>Cancer</li>
                  <li>Gout</li>
                  <li>Non-alcoholic Fatty Liver Disease</li>
                  <li>Autoimmune conditions</li>
                </ul>
                
                <h3 className="text-lg font-semibold text-primary">Our Approach</h3>
                <p className="text-gray-600 leading-relaxed">
                  We use the latest evidence-based guidelines to create nutrition plans that help manage symptoms, slow disease progression, and improve your overall health and well-being.
                </p>
                
                <div className="mt-8 flex justify-center">
                  <Link to="/booking">
                    <Button size="lg" className="bg-primary hover:bg-primary-light text-white px-8">
                      Book a Consultation
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </>;
};
export default ChronicDiseases;